import React from 'react'
import ContractTabs from '../../components/contractmanagement/ContractTabs';
import ContractManagementCreate from '../../components/contractmanagement/ContractManagementCreate';

function ContractManagementCreatePage({ renderPageContent }) {
    return (
        <>
            {/*Dynamic content goes here */}
            <ContractManagementCreate renderPageContent={renderPageContent} />


        </>
    )
}

export default ContractManagementCreatePage;